import React from 'react';
import MainEnvironment from './main-environment';
import ExperienceEnvironment from './experience-environment';
// import { useLocation } from 'react-router-dom';
import { matchPath } from 'react-router';

type TEnvironmentProps = React.Props<{}> & {};

const Environment = ({ children }: TEnvironmentProps) => {
  // const location = useLocation();

  const res = matchPath(window.location.pathname, {
    path: ['/live/embed/:experienceId','/slideshow/embed/:slideshowId', '/:city/experience/:experienceId', '/:city/place/:placeId/action-video/:type'],
    exact: true,
  });

  const Component = res ? ExperienceEnvironment : MainEnvironment;

  return <Component>{children}</Component>;
};

export default Environment;
